import { Control } from 'node_modules/react-hook-form/dist/types/form'
import { useTranslation } from 'react-i18next'

import { InputControl } from '../../components/form-controls'

import { inputValidations } from '@/utils/inputValidations'
interface EmailsProps {
    control: Control<any>
    email: any
}
export const Emails = ({ control, email }: EmailsProps): JSX.Element => {
    const { t } = useTranslation()

    return (
        <div className="space-y-5">
            <InputControl
                allowedPattern={inputValidations.emailPattern}
                preserveCase
                name="email"
                control={control}
                label={t('forms.common.email')}
                rules={{
                    required: t('forms.common.required.emailRequired'),
                    pattern: {
                        value: inputValidations.isValidEmail,
                        message: t('createAccount.invalidEmail')
                    }
                }}
            />
            <InputControl
                allowedPattern={inputValidations.emailPattern}
                preserveCase
                name="emailConfirmation"
                control={control}
                label={t('createAccount.emailConfirmation')}
                onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
                    e.preventDefault()
                }}
                rules={{
                    required: t('forms.common.required.emailRequired'),
                    pattern: {
                        value: inputValidations.isValidEmail,
                        message: t('createAccount.invalidEmail')
                    },
                    validate: (value) =>
                        value === email || t('createAccount.emailsMustMatch')
                }}
            />
        </div>
    )
}
